import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, DropdownButton, Dropdown } from 'react-bootstrap';
import DeleteButton from './DeleteButton';
import FontAwesome from 'react-fontawesome';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';
import Card from '../../common/components/Card';
import ui from '../../common/services/ui';
import CustomDropdownMenu from '../../common/components/CustomDropdownMenu';

const List = ({ t, data, showOptions, onSelect, onSelectNew, canDelete, onDelete, enableCollectMedicalInformation, ...rest }) => {
	const showGender = false;

	const cardStyle = { height: 180, textAlign: 'center', position: 'relative' };
	const avatarStyle = { width: 56, height: 56, lineHeight: '56px', fontSize: 18, display: 'inline-block', marginBottom: 15 };
	const avatarColors = ['bg-purple', 'bg-green', 'bg-orange', 'bg-blue'];

	const renderOptionsMenu = (child) => canDelete && <Dropdown style={{ position: 'absolute', top: 5, right: 10 }}>
		<a bsRole='toggle' style={{ padding: 5, cursor: 'pointer' }}><FontAwesome name='ellipsis-v' className='text-muted' /></a>
		<CustomDropdownMenu bsRole='menu' className='dropdown-menu-right'>
			{canDelete && <li><DeleteButton child={child} onDelete={onDelete} /></li>}
			{/*<li> <Link to={`/children/${child.id}/history`}><FontAwesome name='history' /> {t('FO_Child_History')}</Link></li>
			<li> <Link to={`/children/${child.id}/makeupSummary`}><FontAwesome name='list' /> {t('FO_Child_MakeupSummary')}</Link></li>
			{enableCollectMedicalInformation && <li><Link to={`/children/${child.id}/medicalInformation`}><FontAwesome name='medkit' /> {t('FO_Child_MedicalInformation')}</Link></li>}*/}
		</CustomDropdownMenu>
	</Dropdown>;

	return (
		<Row>
			{data.map(child => <Col sm={6} md={4} key={child.id}>
				<Card style={cardStyle}>
					{showOptions && renderOptionsMenu(child)}
					<a onClick={() => onSelect(child)} style={{ display: 'block', cursor: 'pointer', textDecoration: 'none' }}>
						<div className={`circle-icon text-white ${avatarColors[child.id % avatarColors.length]}`} style={avatarStyle}>{ui.getAvatarName(child.firstName, child.lastName)}</div>
						<h4>{child.fullName} {enableCollectMedicalInformation && !child.hasMedicalInformation && <FontAwesome style={{ color: 'red' }} name='medkit' />}</h4>
						<div className='text-muted'>{moment(child.dateOfBirth).format('L')}</div>
						{showGender && <div className='text-muted'>{child.gender && t(`GenderType_${child.gender.name}`)}</div>}
					</a>
				</Card>
			</Col>)
			}
			<Col sm={6} md={4} key='new_child'>
				<Card className='card-dashed' style={{ ...cardStyle, lineHeight: '120px' }}>
					<a onClick={onSelectNew} style={{ textDecoration: 'none', cursor: 'pointer' }}><span className='text-muted' style={{ fontSize: 20 }}><FontAwesome name='plus' /> {t('FO_Child_New')}</span></a>
				</Card>
			</Col>
		</Row>
	);
};

List.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		fullName: PropTypes.string,
		gender: PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string
		}),
		dateOfBirth: PropTypes.string
	})),
	canDelete: PropTypes.bool,
	onDelete: PropTypes.func
};

export default withNamespaces()(List);